<script setup>
import IconGiftHeroBug from "~/svg/badge-gift-hero-bug.svg";
import IconSparkles from "~/svg/badge-sparkles.svg";

/**
 * Corner badge shared by the friend card and the Find Friends legend
 * (GH-1095, Figma 224-711 / 224-739): the Gift Hero bug with a sparkle
 * poking past the dark square, or the Expert lightning bolt on the same
 * square. The parent positions it; the root carries no position class.
 */
defineProps({
    kind: {
        type: String,
        required: true,
        validator: (kind) => ["gift-hero", "expert"].includes(kind),
    },
});
</script>

<template>
    <span
        v-if="kind === 'gift-hero'"
        class="block size-[30px] rounded-[2px] bg-black/40"
        title="Gift Hero"
    >
        <IconGiftHeroBug
            class="absolute left-[7px] top-[6px] size-[17px]"
            aria-hidden="true"
        />
        <IconSparkles
            class="absolute -right-[6px] -top-[5px] size-[13px]"
            aria-hidden="true"
        />
    </span>
    <span
        v-else
        class="grid size-[30px] place-items-center rounded-[2px] bg-black/40"
        title="Expert"
    >
        <img
            :src="asset('images/profile/badge-top-contributor.png')"
            alt="Expert"
            class="size-[15px]"
        />
    </span>
</template>
